import React, { createElement } from "react";
import { BannerProps } from "./index";
import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";
import { getCloudinaryOptimizedUrl } from "@companion-core/shared/app/Utils/cloudinary";
import "Assets/Styles/scss/banner.scss";

export const Banner = ({
  title = "",
  subtitle = "",
  imageUrl,
  imageUrlFallback = "",
  boxShadow = false,
  shadowType = "default",
  overlap = true,
  disappearOnMobileSize = false,
  variant = "center",
  children,
  titleTag = "h2",
}: BannerProps) => {
  const isMobileSize = useMediaQuery("(max-width: 768px)");

  const titleElement =
    title && typeof title === "string"
      ? createElement(
          titleTag,
          {
            "data-testid": "banner__title",
            className: "super-title-1 banner__title",
          },
          title
        )
      : undefined;

  const backgroundImage = `url("${getCloudinaryOptimizedUrl(imageUrl, {
    contentType: "banner",
    width: window.innerWidth,
    height: 310,
  })}")${imageUrlFallback ? `, url("${imageUrlFallback}")` : ""}`;

  const hasCustomTextContent =
    (title && typeof title !== "string") || (subtitle && typeof subtitle !== "string");

  return (
    ((isMobileSize && !disappearOnMobileSize) || !isMobileSize) && (
      <div data-testid="banner" className={`banner${overlap ? "" : " banner--no-overlap"}`}>
        <div
          data-testid="banner__content"
          className={`banner__content banner__content--${variant}`}
          aria-hidden="true">
          <div className="banner__media" style={{ backgroundImage }} />
          {boxShadow && (
            <div
              data-testid="banner__shadow"
              className={`banner__shadowed-background ${
                shadowType === "gradient" ? "banner__shadowed-background--gradient" : ""
              }`}
            />
          )}
        </div>
        <div
          className={`banner__text banner__text--${variant}`}
          {...(hasCustomTextContent ? { role: "presentation" } : {})}>
          {title && typeof title === "string" ? titleElement : title}
          {subtitle && typeof subtitle === "string" ? (
            <span data-testid="banner__subtitle" className="body-text-2 banner__subtitle">
              {subtitle}
            </span>
          ) : (
            subtitle
          )}
          {children}
        </div>
      </div>
    )
  );
};
